import { createNode, ZonedDateTimeDataType } from '@glueapp/graph-types';
import { toZonedDateTime, fromZonedDateTime } from '../../utils/temporal';

export const ChangeTimezone = createNode({
    id: 'Change Timezone',
    name: 'Change Timezone',
    description: 'Changes the timezone of a ZonedDateTime, preserving the same instant in time',
    aiDescription:
        'Takes a ZonedDateTime on the "ZonedDateTime" port and a timezone string on the "New Timezone" port, and outputs a new ZonedDateTime on the "ZonedDateTime" port with the timezone changed while preserving the same instant.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
        'New Timezone': { kind: 'string' },
    },
    outPorts: {
        ZonedDateTime: ZonedDateTimeDataType,
    },
    execute: function (input) {
        const zdt = toZonedDateTime(input.inPorts.ZonedDateTime);
        const result = zdt.withTimeZone(input.inPorts['New Timezone']);
        return { output: { ZonedDateTime: fromZonedDateTime(result) } };
    },
});
